
import { Injectable } from '@angular/core';

import { tPeriodRangeMapping, tLoadingElement, tLoadingElementWithSuccess, tLoadingElementWithSuccessAndErrorObj } from './ui.typings';
import { tModeDirectoryApplication } from './app-config.typings';

@Injectable()

export class UIConfigService {

  //This service classifies the resource types as are required for the vatious vetypes
  periodRangeMapping: tPeriodRangeMapping;

  constructor() {

  }

  public getPeriodRangeConfigurations() {

    this.periodRangeMapping = {
      "minute": {
        "range": "day",
        "apiFormat": "PT1M",
        "datePipeFormat": "dd-MM-yyyy HH:mm"
      },
      "30minute": {
        "range": "day",
        "apiFormat": "PT30M",
        "datePipeFormat": "dd-MM-yyyy HH:mm"
      },
      "hour": {
        "range": "day",
        "apiFormat": "PT1H",
        "datePipeFormat": "dd-MM-yyyy HH:mm"
      },
      "day": {
        "range": "week",
        "apiFormat": "P1D",
        "datePipeFormat": "EEE dd MMM y"
      },
      "week": {
        "range": "month",
        "apiFormat": "P1W",
        "datePipeFormat": "EEE dd MMM y"
      },
      "month": {
        "range": "year",
        "apiFormat": "P1M",
        "datePipeFormat": "MMM y"
      }
    }
    return this.periodRangeMapping;
  };

  public initialiseLoadingBooleans(loading=true): tLoadingElement {
    return {
      loading: loading,
      loaded: false,
      errorString: '',
      loadError: false
    }
  }

  public initialiseLoadingBooleansWithLoadedMsg(loading = true): tLoadingElementWithSuccess {
    return { ...this.initialiseLoadingBooleans(loading), loadedMessage: null };
  }

  public initialiseLoadingBooleansWithLoadedMsgErrorObj(loading = true): tLoadingElementWithSuccessAndErrorObj {
    return { ...this.initialiseLoadingBooleansWithLoadedMsg(loading), loadedMessage: null, errorObj: {} };
  }

  public initialiseModeObj(): tModeDirectoryApplication {
    return {
      mode: null,
      directory: null,
      application: null
    }
  }
};




